module.exports = __webpack_public_path__ + "static/media/mandrivaboot.2fdac8dd.jpg";